import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Typography,
	Box,
	Stack,
	IconButton,
} from "@mui/material";
import { IconLogin, IconX, IconLock } from "@tabler/icons-react";
import { useThreadsAuth } from "../../hooks/useThreadsAuth";
import { redirectToCollectionLogin } from "../../utils/collectionLogin";

const CollectionLoginPromptModal = ({ open, onClose, isMobile }) => {
  const { login: threadsLogin } = useThreadsAuth();
	const handleDismiss = () => {
		onClose?.("skip");
	};

	const handleLoginClick = () => {
		onClose?.("login");
    redirectToCollectionLogin(threadsLogin);
	};

	return (
		<Dialog
			open={open}
			onClose={handleDismiss}
			maxWidth="sm"
			fullWidth
			fullScreen={isMobile}
			PaperProps={{
				sx: {
					borderRadius: isMobile ? 0 : 2,
					p: isMobile ? 1 : 2,
				},
			}}
		>
			<DialogTitle
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					position: "relative",
					pb: 1,
				}}
			>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						gap: 1,
					}}
				>
					<IconLock size={22} />
					<Typography
						variant="h6"
						component="span"
						sx={{ fontWeight: 700, letterSpacing: "-0.01em" }}
					>
						컬렉션 전체 보기
					</Typography>
				</Box>
				<IconButton
					onClick={handleDismiss}
					size="small"
					sx={{
						position: "absolute",
						right: isMobile ? 0 : 8,
						top: "50%",
						transform: "translateY(-50%)",
						color: "text.secondary",
					}}
				>
					<IconX size={20} />
				</IconButton>
			</DialogTitle>

			<DialogContent sx={{ pt: 2 }}>
				<Stack spacing={3}>
					<Typography
						variant="body1"
						sx={{
							textAlign: "center",
							color: "text.secondary",
							wordBreak: "keep-all",
						}}
					>
						첫 문단 이후의 본문, 이미지, 댓글은 Threads API를 통해 제공돼요.
						<br />
						로그인하고 컬렉션의 모든 이야기를 끝까지 읽어보세요.
					</Typography>

					<Box
						sx={{
							borderRadius: 2,
							border: "1px solid",
							borderColor: "divider",
							p: 2.5,
							backgroundColor: "background.paper",
						}}
					>
						<Stack spacing={1}>
							<Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
								로그인 시 제공되는 내용
							</Typography>
							<Typography variant="body2" color="text.secondary">
								• 전체 본문과 이어지는 댓글
								<br />
								• 원본 이미지 및 미디어
								<br />
								• 컬렉션 참여자 활동 정보
							</Typography>
						</Stack>
					</Box>
				</Stack>
			</DialogContent>

			<DialogActions
				sx={{
					pt: 1,
					pb: isMobile ? 2 : 3,
					px: isMobile ? 2 : 3,
					display: "flex",
					flexDirection: isMobile ? "column" : "row",
					gap: 1,
				}}
			>
				<Button
					variant={isMobile ? "outlined" : "text"}
					fullWidth={isMobile}
					onClick={handleDismiss}
					sx={{
						fontWeight: 600,
						color: "text.secondary",
					}}
				>
					그냥 볼래요
				</Button>
				<Button
					variant="contained"
					fullWidth={isMobile}
					onClick={handleLoginClick}
					startIcon={<IconLogin size={18} />}
					sx={{ fontWeight: 700 }}
				>
					Threads로 로그인
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CollectionLoginPromptModal;
